import { delayedTrackZustand } from '@fabric-app/compat/capabilities/openreplay';
import { create } from 'zustand';
import { persist, createJSONStorage } from '../../../node_modules/zustand/esm/middleware.js';

const defaultHistoryState = [];
const userNavigationHistoryStore = create()(persist(delayedTrackZustand((set) => ({
  lastState: void 0,
  history: defaultHistoryState,
  resetHistory: () => set({
    history: defaultHistoryState,
    lastState: void 0
  }),
  removeItemsFromHistory: (shouldRemoveFn) => {
    set((state) => {
      const nextHistory = state.history.filter((item) => !shouldRemoveFn(item));
      const nextLastState = nextHistory[0];
      return {
        history: nextHistory,
        lastState: nextLastState
      };
    });
  }
}), "safe-navigation-history"), {
  name: "safe-navigation-history",
  // use sesssion storage to store the history this way it specific to the tab
  storage: createJSONStorage(() => sessionStorage)
}));
const getUserNavigationHistory = () => {
  return userNavigationHistoryStore.getState();
};
const removeItemsWithProvidedIdFromHistory = (id) => {
  getUserNavigationHistory().removeItemsFromHistory((item) => {
    return typeof id === "string" ? item.asPath.includes(id) : id.some((uuid) => item.asPath.includes(uuid));
  });
};

export { getUserNavigationHistory, removeItemsWithProvidedIdFromHistory, userNavigationHistoryStore };
//# sourceMappingURL=userNavigationHistoryStore.js.map
